import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, mergeProps as _mergeProps, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-276bd708")

_pushScopeId("data-v-276bd708")
const _hoisted_1 = {
  id: "kt_objective",
  class: "bg-white drawer",
  "data-kt-drawer": "true",
  "data-kt-drawer-name": "objective",
  "data-kt-drawer-activate": "true",
  "data-kt-drawer-overlay": "true",
  "data-kt-drawer-width": "{default:'100%', 'lg': '900px'}",
  "data-kt-drawer-direction": "end",
  "data-kt-drawer-toggle": "#kt_objective_toggle",
  "data-kt-drawer-close": "#kt_objective_close"
}
const _hoisted_2 = { class: "card shadow-none" }
const _hoisted_3 = { class: "customModal-header" }
const _hoisted_4 = {
  id: "main_modal_track",
  class: "d-flex justify-content-between"
}
const _hoisted_5 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_6 = {
  key: 1,
  class: "d-flex align-items-center"
}
const _hoisted_7 = { class: "d-flex align-items-center" }
const _hoisted_8 = {
  key: 0,
  src: "/media/icons/new/add.png",
  width: "30",
  height: "30"
}
const _hoisted_9 = {
  key: 1,
  src: "/media/icons/new/back.png",
  width: "30",
  height: "30"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("img", {
  width: "30",
  height: "30",
  src: "/media/icons/new/info.png"
}, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("img", {
  width: "30",
  height: "30",
  src: "/media/icons/new/share.png"
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("img", {
  width: "30",
  height: "30",
  src: "/media/icons/new/trash.png"
}, null, -1)
const _hoisted_13 = {
  type: "button",
  class: "btn btn-sm btn-icon btn-active-light-primary me-n5",
  id: "kt_objective_close"
}
const _hoisted_14 = { class: "percent" }
const _hoisted_15 = {
  class: "card-body drawer-body",
  id: "kt_objective_body"
}
const _hoisted_16 = { class: "modal-left" }
const _hoisted_17 = { class: "modal-right" }
const _hoisted_18 = {
  key: 0,
  class: "customModal-footer"
}
const _hoisted_19 = /*#__PURE__*/_createVNode("img", {
  width: "30",
  height: "30",
  src: "/media/icons/new/prev.png"
}, null, -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("img", {
  width: "30",
  height: "30",
  src: "/media/icons/new/next.png"
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_PercentSection = _resolveComponent("PercentSection")
  const _component_Left = _resolveComponent("Left")
  const _component_Right = _resolveComponent("Right")
  const _component_ProceedAnyway = _resolveComponent("ProceedAnyway")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          (_ctx.form.add !== true)
            ? (_openBlock(), _createBlock("div", _hoisted_5, [
                _createVNode("span", {
                  class: ["badge rounded-pill", 
                _ctx.form.relativeAdvance <= 40
                  ? 'bg-danger'
                  : _ctx.form.relativeAdvance < 70
                  ? 'bg-warning'
                  : 'bg-success'
              ],
                  style: { background: _ctx.isBlue(_ctx.form) ? '#597dfe !important' : '' }
                }, _toDisplayString(_ctx.form.parent || _ctx.form.type === "key_result"
                  ? _ctx.form.type === "key_result"
                    ? "KR"
                    : "O"
                  : "OMI"), 7),
                _createVNode("span", {
                  class: "element-title syncTitle",
                  id: 'title-' + _ctx.form.id,
                  "data-bs-toggle": "tooltip",
                  "data-bs-placement": "top"
                }, _toDisplayString(_ctx.syncTitle.title), 9, ["id"])
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_6, [
                _createVNode("span", {
                  class: ["badge rounded-pill", 
                _ctx.form.relativeAdvance <= 40
                  ? 'bg-danger'
                  : _ctx.form.relativeAdvance < 70
                  ? 'bg-warning'
                  : 'bg-success'
              ],
                  style: { background: _ctx.isBlue(_ctx.form) ? '#597dfe !important' : '' }
                }, _toDisplayString(_ctx.syncTitle.type === ""
                  ? _ctx.translate("new")
                  : _ctx.syncTitle.type === "key_result"
                  ? "KR"
                  : "O"), 7),
                _createVNode("span", {
                  class: "element-title syncTitle",
                  id: 'title-' + _ctx.form.id,
                  "data-bs-toggle": "tooltip",
                  "data-bs-placement": "top"
                }, _toDisplayString(_ctx.syncTitle.title), 9, ["id"])
              ])),
          _createVNode("div", _hoisted_7, [
            (_ctx.isPlanning && !_ctx.isTypeUser && _ctx.form.type !== 'key_result')
              ? (_openBlock(), _createBlock("button", {
                  key: 0,
                  class: "btn btn-icon noBorder",
                  title: _ctx.translate(`New`),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.newSubObjective()))
                }, [
                  (_ctx.form.add !== true)
                    ? (_openBlock(), _createBlock("img", _hoisted_8))
                    : (_openBlock(), _createBlock("img", _hoisted_9))
                ], 8, ["title"]))
              : (_ctx.form.type !== 'key_result')
                ? (_openBlock(), _createBlock("button", {
                    key: 1,
                    class: "btn btn-icon noBorder",
                    title: _ctx.translate(`New`)
                  }, [
                    _createVNode("img", {
                      src: "/media/icons/new/add.png",
                      width: "30",
                      height: "30",
                      "data-bs-toggle": "tooltip",
                      title: _ctx.translate(`isPlanning`),
                      class: "gray-icon"
                    }, null, 8, ["title"])
                  ], 8, ["title"]))
                : _createCommentVNode("", true),
            _createVNode("button", {
              "data-bs-toggle": "modal",
              "data-bs-target": "#_app_objective-info_modal",
              "data-bs-placement": "top",
              title: _ctx.translate(`info`),
              class: "btn btn-icon"
            }, [
              _hoisted_10
            ], 8, ["title"]),
            _createVNode("button", {
              "data-bs-toggle": "modal",
              "data-bs-target": "#_app_objective-sharer_modal",
              "data-bs-placement": "top",
              title: _ctx.translate(`Share`),
              class: "btn btn-icon"
            }, [
              _hoisted_11
            ], 8, ["title"]),
            _createVNode("button", {
              "data-bs-toggle": "modal",
              "data-bs-target": "#_app_objective_removing_confirmed_modal",
              "data-bs-placement": "top",
              title: _ctx.translate(`Delete`),
              class: "btn btn-icon me-10"
            }, [
              _hoisted_12
            ], 8, ["title"]),
            _createVNode("button", _hoisted_13, [
              _createVNode(_component_inline_svg, { src: "/media/icons/duotone/Navigation/Close.svg" })
            ])
          ])
        ]),
        _createVNode("div", _hoisted_14, [
          _createVNode(_component_PercentSection, { element: _ctx.form }, null, 8, ["element"])
        ])
      ]),
      _createVNode("div", _hoisted_15, [
        _createVNode("div", _hoisted_16, [
          _createVNode(_component_Left, {
            translate: _ctx.translate,
            ref: "childRef"
          }, null, 8, ["translate"])
        ]),
        _createVNode("div", _hoisted_17, [
          _createVNode(_component_Right, { translate: _ctx.translate }, null, 8, ["translate"])
        ])
      ])
    ]),
    (_ctx.canNavigate)
      ? (_openBlock(), _createBlock("div", _hoisted_18, [
          _createVNode("button", _mergeProps(_ctx.modalAttributes, {
            onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.prev && _ctx.prev(...args)), ["prevent"])),
            class: "floating-button left"
          }), [
            _hoisted_19
          ], 16),
          _createVNode("button", _mergeProps(_ctx.modalAttributes, {
            onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args)), ["prevent"])),
            class: "floating-button right"
          }), [
            _hoisted_20
          ], 16)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_ProceedAnyway, { action: _ctx.actionType }, null, 8, ["action"])
  ]))
})